import { createApp } from 'vue'
import BasketCard from './BasketCard'

const el = '.kb-component--basket-card'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((BasketCardDOM) => {
            const component = createApp(BasketCard).use(Store)
            component.mount(BasketCardDOM)
        })
    }
}
